export enum MlTrainingDialogType {
    NEW_MODEL = 'new-model',
    CONTINUE_TRAINING = 'continue-training',
    NEW_MODEL_OR_CONTINUE_TRAINING = 'new-model-or-continue-training',
}
